var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-2":"cover-back","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('PreviewLayersCoverBackContourPH2L',{attrs:{"params":_vm.params}}),(_vm.params.cornersBackComponent)?_c(`PreviewLayersCoverBackCorners${_vm.params.cornersBackComponent}`,{tag:"component",attrs:{"params":_vm.params}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }